import { SnackbarKey } from "notistack";
import * as actionTypes from "./actionTypes";
import * as types from "./types";

export const enqueueSnackbar = (notification: types.INotification) => {
    const key = notification.options && notification.options.key;

    return {
        type: actionTypes.ENQUEUE_SNACKBAR,
        notification: {
            ...notification,
            key: key || new Date().getTime() + Math.random(),
            dismissed: false,
        },
    };
};

export const closeSnackbar = (key: SnackbarKey) => ({
    type: actionTypes.CLOSE_SNACKBAR,
    dismissAll: !key, // dismiss all if no key has been defined
    key,
});

export const removeSnackbar = (key: SnackbarKey) => ({
    type: actionTypes.REMOVE_SNACKBAR,
    removeAll: !key,
    key,
});

// dismiss all if no key has been defined   
export const closeAllSnackbar = () => ({
    type: actionTypes.CLOSE_ALL_SNACKBAR,
});

export const removeAllSnackbar = () => ({
    type: actionTypes.REMOVE_ALL_SNACKBAR,        
});
